import { gql } from "generated-graphql";

gql(`
  fragment TagPicker on Tag {
    id
    name
  }
`);
/**
 * This query is used to fetch all tags for a given tenant and type
 * via the search parameter.
 */
export const TAGS_QUERY = gql(`
  query Tags($search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]) {
    tags(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...TagPicker
      }
      count
    }
  }
`);
